import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetDeceasedSocioEconomicInformationController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetDeceasedSocioEconomicInformationController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/socio-economic-information'
*/
const ElysGetDeceasedSocioEconomicInformationController = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysGetDeceasedSocioEconomicInformationController.url(args, options),
    method: 'get',
})

ElysGetDeceasedSocioEconomicInformationController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/elys/dossier/{dossier_id}/socio-economic-information',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetDeceasedSocioEconomicInformationController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetDeceasedSocioEconomicInformationController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/socio-economic-information'
*/
ElysGetDeceasedSocioEconomicInformationController.url = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            dossier_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        dossier_id: args.dossier_id,
    }

    return ElysGetDeceasedSocioEconomicInformationController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{dossier_id}', parsedArgs.dossier_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetDeceasedSocioEconomicInformationController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetDeceasedSocioEconomicInformationController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/socio-economic-information'
*/
ElysGetDeceasedSocioEconomicInformationController.get = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysGetDeceasedSocioEconomicInformationController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetDeceasedSocioEconomicInformationController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetDeceasedSocioEconomicInformationController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/socio-economic-information'
*/
ElysGetDeceasedSocioEconomicInformationController.head = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ElysGetDeceasedSocioEconomicInformationController.url(args, options),
    method: 'head',
})

export default ElysGetDeceasedSocioEconomicInformationController